import { render } from "./BusinessCooperation.vue?vue&type=template&id=e6dadf78"
import script from "./BusinessCooperation.vue?vue&type=script&lang=js"
export * from "./BusinessCooperation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__